import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from 'src/routes/ProtectedRoute';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import { getPortfolioRoutesAvailability } from 'src/routes/state/routesSelector';
import { useAppSelector } from 'src/store';
import { IndividualRouteSetting, PortfolioViews } from 'src/routes/routesConfig';
import { Resources } from 'src/shared/types';
import PortfolioSummary from './views/portfolio-summary/PortfolioSummary';
import PortfolioSiteExplorer from './views/portfolio-site-explorer/PortfolioSiteExplorer';
import SpeciesRiskIndicators from './views/species-risk-indicators/SpeciesRiskIndicators';
import SiteList from './views/global-nature-risk/site-list/SiteList';
import GnrOverview from './views/global-nature-risk/overview/GnrOverview';
import GnrStateOfNature from './views/global-nature-risk/state-of-nature/GnrStateOfNature';
import GnrImpactsAndDependencies from './views/global-nature-risk/impacts-and-dependencies/GnrImpactsAndDependencies';
import PortfolioFiles from './views/portfolio-files/PortfolioFiles';
import NextSpeciesRiskIndicators from './views/next/NextSpeciesRiskIndicators';
import NextPortfolioSiteExplorer from './views/next/NextPortfolioSiteExplorer';
import NextPortfolioSummary from './views/next/NextPortfolioSummary';

export const portfolioRouteSettings: { [key in PortfolioViews]: IndividualRouteSetting } = {
    portfolioSummary: {
        name: 'Portfolio Summary',
        path: '/',
        handler: <PortfolioSummary />,
        resource: Resources.PORTFOLIO_SUMMARY,
    },
    portfolioSiteExplorer: {
        name: 'Portfolio site explorer',
        path: '/site-explorer',
        handler: <PortfolioSiteExplorer />,
        resource: Resources.PORTFOLIO_SITE_EXPLORER,
    },
    speciesRiskIndicators: {
        name: 'Portfolio species risks',
        path: '/species-risk-indicators',
        handler: <SpeciesRiskIndicators />,
        resource: Resources.PORTFOLIO_SPECIES_RISK_INDICATORS,
    },
    nextSpeciesRiskIndicators: {
        name: 'Portfolio species risks (new)',
        path: '/next/species-risk-indicators',
        handler: <NextSpeciesRiskIndicators />,
        resource: Resources.PORTFOLIO_SPECIES_RISK_INDICATORS,
    },
    nextPortfolioSiteExplorer: {
        name: 'Portfolio site explorer (new)',
        path: '/next/site-explorer',
        handler: <NextPortfolioSiteExplorer />,
        resource: Resources.PORTFOLIO_SITE_EXPLORER,
    },
    nextPortfolioSummary: {
        name: 'Portfolio summary (new)',
        path: '/next/summary',
        handler: <NextPortfolioSummary />,
        resource: Resources.PORTFOLIO_SUMMARY,
    },
    globalNatureRiskOverview: {
        name: 'Global Nature Risk Overview',
        path: '/global-nature-risk/overview',
        handler: <GnrOverview />,
        resource: Resources.PORTFOLIO_RISK_INSIGHTS,
    },
    globalNatureRiskStateOfNature: {
        name: 'Global Nature Risk State of Nature',
        path: '/global-nature-risk/state-of-nature',
        handler: <GnrStateOfNature />,
        resource: Resources.PORTFOLIO_RISK_INSIGHTS,
    },
    globalNatureRiskImpactsAndDependencies: {
        name: 'Global Nature Risk Impacts and Dependencies',
        path: '/global-nature-risk/impacts-and-dependencies',
        handler: <GnrImpactsAndDependencies />,
        resource: Resources.PORTFOLIO_RISK_INSIGHTS,
    },
    globalNatureRiskSiteList: {
        name: 'Global Nature Risk',
        path: '/global-nature-risk/site-list',
        handler: <SiteList />,
        resource: Resources.PORTFOLIO_RISK_INSIGHTS,
    },
    portfolioFiles: {
        name: 'Portfolio files',
        path: '/portfolio-files',
        handler: <PortfolioFiles />,
        resource: Resources.SITE_FILES,
    },
};

const Portfolio = () => {
    const routesConfig = useAppSelector(getPortfolioRoutesAvailability);

    if (!routesConfig) {
        return null;
    }

    return (
        <Routes>
            {Object.keys(routesConfig).map(routeKey => {
                const isAvailable = routesConfig[routeKey as PortfolioViews];
                const routeSetting = portfolioRouteSettings[routeKey as PortfolioViews];

                if (!routeSetting) {
                    return null;
                }

                return (
                    <Route
                        path={routeSetting.path}
                        element={
                            <ProtectedRoute isAllowed={isAvailable} redirectPath={'/customers'} routeSetting={routeSetting}>
                                {routeSetting.handler}
                            </ProtectedRoute>
                        }
                        key={routeSetting.name}
                    />
                );
            })}
            <Route path='/*' element={<PageNotFound />} />
        </Routes>
    );
};
export default Portfolio;
